export * from './Component'
export type { CommonBackdropProps } from './typing'
